import { createRoot } from "react-dom/client";
import "url:./fonts/GoudyIni.ttf";
import App from "./App";
import "./index.css";

const container = document.getElementById("app");
const root = createRoot(container);
root.render(<App />);
